import { showFromFade } from "../../js/Util";

if ($(".case").length) {
    $(".case")
        .each((index, item) => {
            const start =
                $(document).width() >= 768
                    ? "top bottom-=20%"
                    : "top bottom-=10%";
            showFromFade(item, start);
        });
}